var exports = {
  "CommunityFooter": "CommunityFooter__cRboXI",
  "CommunityFooter__header": "CommunityFooter__header__jVdD3_",
  "CommunityFooter__body": "CommunityFooter__body__K7IAon",
  "CommunityFooter__hero": "CommunityFooter__hero__TZD-PL",
  "CommunityFooter__label": "CommunityFooter__label__4RXAr-",
  "CommunityFooter__heading": "CommunityFooter__heading__nSCsTX",
  "CommunityFooter__signUpForm": "CommunityFooter__signUpForm__1c3WTM",
};

__webpack_require__.r(module.exports = exports);
